import { forwardRef, lazy, Suspense } from 'react';
import type { RichEditorHandle, RichEditorProps } from './RichEditor.js';

// TipTap/ProseMirror is most of the editor's weight; load it only where an editor renders
const RichEditorImpl = lazy(() => import('./RichEditor.js').then((m) => ({ default: m.RichEditor })));

export const LazyRichEditor = forwardRef<RichEditorHandle, RichEditorProps>(function LazyRichEditor(props, ref) {
  return (
    <Suspense fallback={<div className="animate-pulse rounded-lg border bg-gray-50" style={{ height: (props.minHeight ?? 96) + 40 }} />}>
      <RichEditorImpl ref={ref} {...props} />
    </Suspense>
  );
});
